import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { TiltIndicator, TILT_INDICATOR_HEIGHT } from "./tilt-indicator";

// The target dot's outer size
const DOT_OUTER = 24;

// Scan indications, containing the center dot, and a reference-object hint
// under it.
export const ScanIndication = ({
  recording,
  useQRCode,
  useCreditCard,
  usePaper,
  showTilt,
  tilt,
  targetTilt,
  onTiltReady,
}) => {
  const hint = recording
    ? "Aim on target"
    : useQRCode
      ? "Make sure to place QR code\nclose to the target"
      : useCreditCard
        ? "Make sure to place credit card\ninside the view"
        : usePaper
          ? "Make sure to place the paper\ninside the view"
          : null;
  const hintColor = recording ? "#fff" : "#f75151";

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: DOT_OUTER,
        height: DOT_OUTER,
        pointerEvents: "none",
      }}
    >
      {showTilt ? (
        // Tilt indicator with its ring sitting exactly on where the target
        // dots are positioned
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <TiltIndicator
            tilt={tilt}
            targetTilt={targetTilt}
            onScanReady={onTiltReady}
          />
        </Box>
      ) : (
        // The target circles if tilt indicator is not available
        <Box
          sx={{
            width: DOT_OUTER,
            height: DOT_OUTER,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #fff",
            boxShadow: "0 0 0 1px rgba(0,0,0,0.3), 0 0 8px rgba(0,0,0,0.6)",
          }}
        >
          <Box
            sx={{
              width: DOT_OUTER * 0.65,
              height: DOT_OUTER * 0.65,
              borderRadius: "50%",
              backgroundColor: "#fff",
              boxShadow: "0 0 0 1px rgba(0,0,0,0.3), 0 0 8px rgba(0,0,0,0.6)",
            }}
          />
        </Box>
      )}

      {/* Hint text located beneath the target dots (or tilt bar if available) */}
      {hint && (
        <Typography
          align="center"
          sx={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: `
                ${
                  showTilt ? 32 + (TILT_INDICATOR_HEIGHT - DOT_OUTER) / 2 : 16
                }px
              `,
            width: "max-content",
            maxWidth: "calc(100vw - 32px)",
            color: hintColor,
            fontSize: 20,
            fontWeight: "bold",
            textShadow: [
              "-1px -1px 0 rgba(0,0,0,0.2)",
              "0 -1px 0 rgba(0,0,0,0.2)",
              "1px -1px 0 rgba(0,0,0,0.2)",
              "-1px 0 0 rgba(0,0,0,0.2)",
              "1px 0 0 rgba(0,0,0,0.2)",
              "-1px 1px 0 rgba(0,0,0,0.2)",
              "0 1px 0 rgba(0,0,0,0.2)",
              "1px 1px 0 rgba(0,0,0,0.2)",
            ].join(", "),
            whiteSpace: "pre-line",
          }}
        >
          {hint}
        </Typography>
      )}
    </Box>
  );
};

ScanIndication.propTypes = {
  recording: PropTypes.bool,
  useQRCode: PropTypes.bool,
  useCreditCard: PropTypes.bool,
  usePaper: PropTypes.bool,
  showTilt: PropTypes.bool,
  tilt: PropTypes.number,
  targetTilt: PropTypes.number,
  onTiltReady: PropTypes.func,
};
